var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{ref:"canvas",class:_vm.$style.canvas,attrs:{"viewBox":_vm.viewBox,"preserveAspectRatio":"xMidYMid meet"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }